module.exports = __webpack_public_path__ + "static/img/font-lg-smart@t.5d318ee.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lgchem/font-lg-smart@t.png
// module id = s8Ag
// module chunks = 0